var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var History = require('backbone-torso/modules/history');
var sessionStorageService = require('./../../../storage/sessionStorageService');
var authErrorTemplate = require('./eregAuthErrorTemplate.hbs');

var SERIAL_NUMBER_PROPERTY_NAME = sessionStorageService.SESSION_STORAGE_KEYS.serialNumber;

/**
 * Generic Error view for tablet authentication
 *
 * @class AuthFormView
 * @constructor
 */
var EregAuthErrorView = TorsoView.extend({
  tagName: 'main',
  className: 'brec-authentication__main tablet-authentication__main',
  template: authErrorTemplate,

  errorMessageKey: 'eregAuth.error.patientAuth',
  buttonOneMessageKey: 'eregAuth.error.button.ok',
  buttonOneNavFunction: function() {
    History.navigate('tablet/serialNumber/' + sessionStorageService.getItem(SERIAL_NUMBER_PROPERTY_NAME), {trigger: true});
  },
  buttonTwoMessageKey: undefined,
  buttonTwoNavFunction: undefined,

  /**
   * Events for the two buttons to
   * @property events {Object}
   * @property events.'click [data-configuration-property-reset]' {String}
   */
  events: {
    'click [data-button-auth-error-one]': 'buttonOneNavFunction',
    'click [data-button-auth-error-two]': 'buttonTwoNavFunction'
  },

  prepareFields: {
    errorMessageKey: 'errorMessageKey',
    buttonOneMessageKey: 'buttonOneMessageKey',
    buttonTwoMessageKey: 'buttonTwoMessageKey',
    hasSecondButton: function() {
      return !_.isUndefined(this.buttonTwoMessageKey) && !_.isUndefined(this.buttonTwoNavFunction);
    }
  }
});

module.exports = EregAuthErrorView;
